export default __webpack_public_path__ + "static/media/EmergencyInfo.021e1ac9.svg";